import React from 'react';
import {connect} from 'react-redux';

import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';

import {getConfigByContext} from '#core/utils/config-utils.js';
import {formatDateFromMask} from '#core/utils/date-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';
import {isMobile} from '#core/utils/context-utils.js';

import {CurrentTime} from '#core/components/current-time.jsx';
import {IconsRow} from '#core/components/incons-row.jsx';
import {SimpleIcon} from '#core/components/simple-icon.jsx';

import {COLOR, FONT} from '../../config/theme.js';
import INTENT from '../../config/intent.js';
import * as aliraSelectors from '../../alira/store/selectors.js';

const {dispatch} = MojitoCore.Services.redux.store;
const IntentActions = MojitoCore.Intents.actions;
const uiStyle = MojitoCore.Presentation.uiStyle;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const authenticationSelectors = MojitoServices.Authentication.selectors;
const SessionTime = MojitoPresentation.Components.SessionTime;
const {selectors: UserSettingsSelectors} = MojitoServices.UserSettings;
const MessagingTypes = MojitoServices.Messaging.types;
const {SHOW_SIMPLE_ALERT} = MessagingTypes.INCOMING_MESSAGES;

const COLORS = {
    DEBUG_COLOR: '#426682',
    LINK: '#17d2ad',
};

class ApplicationFooter extends UIViewImplementation {
    constructor(props) {
        super(props);
        this.ICONS = {
            SOCIAL_MEDIA: [
                {
                    icon: '/images/application-footer/social_youtube.png',
                    width: 48,
                    height: 48,
                    intent: INTENT.FOOTER.YOUTUBE,
                    _mobile_width: 32,
                    _mobile_height: 32,
                    windowName: 'newWindow',
                    taId: 'ta-youtube-icon',
                    alt: 'YouTube',
                },
                {
                    icon: '/images/application-footer/social_instagram.png',
                    width: 48,
                    height: 48,
                    intent: INTENT.FOOTER.INSTAGRAM,
                    _mobile_width: 32,
                    _mobile_height: 32,
                    windowName: 'newWindow',
                    taId: 'ta-instagram-icon',
                    alt: 'Instagram',
                },
                {
                    icon: '/images/application-footer/social_help.png',
                    width: 48,
                    height: 48,
                    intent: INTENT.FOOTER.HELP,
                    _mobile_width: 32,
                    _mobile_height: 32,
                    windowName: 'newWindow',
                    taId: 'ta-help-icon',
                },
            ],
            PAYMENT: {
                FIRST_ROW: [
                    {
                        icon: '/images/application-footer/payment/icon_payment_visa.png',
                        width: 90,
                        height: 32,
                        _mobile_width: 70,
                        _mobile_height: 24,
                        taId: 'ta-visa',
                        alt: 'VISA Electron',
                    },
                    {
                        icon: '/images/application-footer/payment/icon_payment_mastercard.png',
                        width: 90,
                        height: 32,
                        _mobile_width: 70,
                        _mobile_height: 24,
                        taId: 'ta-Mastercard',
                        alt: 'Mastercard',
                    },
                    {
                        icon: '/images/application-footer/payment/icon_payment_transferencia.png',
                        width: 90,
                        height: 32,
                        _mobile_width: 70,
                        _mobile_height: 24,
                        taId: 'ta-Transferencia',
                        alt: 'Bank transfer',
                    },
                    {
                        icon: '/images/application-footer/payment/icon_payment_pse.png',
                        width: 90,
                        height: 32,
                        _mobile_width: 70,
                        _mobile_height: 24,
                        taId: 'ta-PSE',
                        alt: 'PSE',
                    },
                ],
                SECOND_ROW: [
                    {
                        icon: '/images/application-footer/payment/icon_payment_efecty.png',
                        width: 90,
                        height: 32,
                        _mobile_width: 90,
                        _mobile_height: 32,
                        taId: 'ta-Efecty',
                        alt: 'Efecty',
                    },
                    {
                        icon: '/images/application-footer/payment/icon_payment_dimonex.png',
                        width: 90,
                        height: 32,
                        _mobile_width: 90,
                        _mobile_height: 32,
                        taId: 'ta-Dimonex',
                        alt: 'Dimonex',
                    },
                    {
                        icon: '/images/application-footer/payment/icon_payment_bemovil.png',
                        width: 51,
                        height: 32,
                        _mobile_width: 51,
                        _mobile_height: 32,
                        taId: 'ta-Bemovil',
                        alt: 'Bemovil',
                    },
                ],
                THIRD_ROW: [
                    {
                        icon: '/images/application-footer/payment/icon_payment_puntored.png',
                        width: 110,
                        height: 32,
                        _mobile_width: 110,
                        _mobile_height: 32,
                        taId: 'ta-Puntored',
                        alt: 'Puntored',
                    },
                    {
                        icon: '/images/application-footer/payment/icon_payment_refacil.png',
                        width: 90,
                        height: 32,
                        _mobile_width: 90,
                        _mobile_height: 32,
                        taId: 'ta-refacil',
                        alt: 'Refacil',
                    },
                    {
                        icon: '/images/application-footer/payment/icon_payment_sportiumcash.png',
                        width: 90,
                        height: 32,
                        _mobile_width: 90,
                        _mobile_height: 32,
                        taId: 'ta-sportiumcash',
                        alt: 'Sportium cash',
                    },
                ],
            },
            PLAY_RESPONSIBLE: [
                {
                    icon: '/images/application-footer/playResponsible/legal_juegabien.png',
                    height: 75,
                    _mobile_height: 45,
                    taId: 'ta-jugar-bien-icon',
                    alt: 'juega bien',
                    intent: INTENT.FOOTER.JUEGABIEN,
                    iconStyle: {margin: '0 10px'},
                },
                {
                    icon: '/images/application-footer/playResponsible/legal_18.png',
                    height: 50,
                    _mobile_height: 45,
                    taId: 'ta-18-icon',
                    alt: '18-plus',
                    iconStyle: {margin: '0 10px'},
                },
                {
                    icon: '/images/application-footer/playResponsible/legal_coljuegos.png',
                    height: 75,
                    _mobile_height: 45,
                    taId: 'ta-Coljuegos',
                    intent: INTENT.FOOTER.COLJUEGOS,
                    alt: 'Coljuegos',
                    iconStyle: {margin: '0 10px'},
                },
                {
                    icon: '/images/application-footer/playResponsible/legal_vigiladoSupersalud.png',
                    height: 75,
                    _mobile_height: 45,
                    taId: 'ta-Vigilado-Supersalud',
                    alt: 'Vigilado Supersalud',
                    iconStyle: {margin: '0 10px'},
                },
                {
                    icon: '/images/application-footer/playResponsible/legal_internationalintegrity.png',
                    height: 75,
                    _mobile_height: 45,
                    taId: 'ta-International-Betting',
                    alt: 'International Betting Integrity Association IBIA',
                    iconStyle: {margin: '0 10px'},
                },
            ],
            KINGS_LEAGUE: {
                icon: '/images/application-footer/sportium_patrocinador_kings_league_americas.png',
                height: 170,
                margin: '8px 0px',
                taId: 'ta-Kings-League-Americas',
                alt: 'Kings League',
            },
            CASINOS: [
                {
                    icon: '/images/application-footer/casinos/icon_winner_group.png',
                    height: 60,
                    taId: 'ta-WinnerGroup',
                    alt: 'Winner Group',
                },
                {
                    icon: '/images/application-footer/casinos/icon_rocknjazz.png',
                    height: 60,
                    taId: 'ta-rocknjazz',
                    alt: 'Rock n Jazz Casino',
                },
                {
                    icon: '/images/application-footer/casinos/icon_hollywood.png',
                    height: 60,
                    taId: 'ta-Hollywood',
                    alt: 'Hollywood Casino & Café Concert Bogota',
                },
                {
                    icon: '/images/application-footer/casinos/icon_broadway.png',
                    height: 60,
                    taId: 'ta-Broadway',
                    alt: 'Broadway Casino',
                },
                {
                    icon: '/images/application-footer/casinos/icon_rio.png',
                    height: 60,
                    taId: 'ta-rio',
                    alt: 'Rio Casino',
                },
                {
                    icon: '/images/application-footer/casinos/icon_caribe.png',
                    height: 60,
                    taId: 'ta-caribe',
                    alt: 'Caribe Casino',
                },
                {
                    icon: '/images/application-footer/casinos/icon_condado.png',
                    height: 60,
                    taId: 'ta-Condado',
                    alt: 'Condado Casino',
                },
            ],
        };
    }
    componentDidUpdate(prevProps) {
        const {aliraLoginInfo} = this.props;

        if (prevProps.aliraLoginInfo !== aliraLoginInfo && aliraLoginInfo) {
            this.popupOnLogin(aliraLoginInfo);
        }
    }

    popupOnLogin(loginInfo) {
        let header = this.resolveString('$LOGIN_SUCCESS_POPUP.HEADER') + loginInfo.username;
        let message = `
            <p>${this.resolveString('$LOGIN_SUCCESS_POPUP.LAST_LOGIN_TIME')}</p>
            <p><strong>${formatDateFromMask(
                loginInfo.lastLoginTime,
                'YYYY-MM-DD HH:mm:ss',
                UserSettingsSelectors.selectTimeOffset()
            )}</strong></p>
        `;
        dispatch(
            MojitoServices.Messaging.actions.messageReceive({
                type: SHOW_SIMPLE_ALERT,
                payload: {text: message, headerLabel: header},
            })
        );
    }

    renderLink(text, params) {
        params = params || {};
        const style = params.style || this.style.link;
        let onClick;
        if (params.intent) {
            onClick = () => dispatch(IntentActions.publishIntent(params.intent.type, params.intent.data));
        }
        return (
            <div style={style} onClick={onClick}>
                {text}
            </div>
        );
    }

    renderHeader(text) {
        const style = this.style.linkRowHeader;
        return <div style={style}>{text}</div>;
    }

    renderSectionHeader(text, containerStyle) {
        let headerStyle = {};
        Object.assign(headerStyle, this.style.sectionHeader, containerStyle);

        return <div style={headerStyle}>{text}</div>;
    }

    renderHeaderButton(text) {
        const style = this.style.linkButtonHeader;
        const intent = INTENT.FOOTER.AYUDA;
        const onClick = () => dispatch(IntentActions.publishIntent(intent.type, intent.data));
        return (
            <div style={style} onClick={onClick}>
                {text}
            </div>
        );
    }

    renderAboutSport(style) {
        return (
            <div style={style}>
                {this.renderHeader(this.resolveString('$APPLICATION_FOOTER.ABOUT_SPORT'))}
                <div>
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.ABOUT_US'), {
                        intent: INTENT.FOOTER.ABOUT_US,
                    })}
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.FIND_OUR_STORIES'), {
                        intent: INTENT.FOOTER.FIND_OUR_STORIES,
                    })}
                </div>
            </div>
        );
    }

    renderDesktopTime(style) {
        return (
            <div style={style}>
                {this.renderHeader(this.resolveString('$APPLICATION_FOOTER.DESKTOP_TIME'))}
                <CurrentTime timeOffset={UserSettingsSelectors.selectTimeOffset()} />
            </div>
        );
    }

    renderFooterLinksSection(section) {
        let linkRowStyle = {display: 'flex', flexFlow: 'row wrap', justifyContent: 'center'};
        let headerStyle = {textAlign: 'center', marginTop: '20px'};
        let borderStyle = {borderLeft: '1px solid #ccc', margin: '5px 0'};
        let borderStyle2 = {borderLeft: 'none', margin: '5px 0'};
        return (
            <div style={headerStyle}>
                {this.renderHeader(this.resolveString(section.caption))}
                <div style={linkRowStyle}>
                    {section.items.map((item, index) => {
                        let style = index === 0 ? borderStyle2 : borderStyle;
                        return (
                            <div style={style} key={index}>
                                {this.renderLink(this.resolveString(item.text), {
                                    style: this.style.narrowFooterLinkSmall,
                                    intent: item.intent,
                                })}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    renderHelp(style) {
        return (
            <div style={style}>
                {this.renderHeader(this.resolveString('$APPLICATION_FOOTER.HELP'))}
                <div>
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.PAYMENT_METHODS'), {
                        intent: INTENT.FOOTER.PAYMENT_METHODS,
                    })}
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.FAQ'), {intent: INTENT.FOOTER.FAQ})}
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.CLAIMS_RESOLUTION'), {
                        intent: INTENT.FOOTER.CLAIMS_RESOLUTION,
                    })}
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.WANT_TO_AFFILIATE'), {
                        intent: INTENT.FOOTER.AFFILIATES,
                    })}
                </div>
            </div>
        );
    }

    renderBettingRules(style) {
        return (
            <div style={style}>
                {this.renderHeader(this.resolveString('$APPLICATION_FOOTER.BETTING_RULES'))}
                <div>
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.LIVE_STADTARDS'), {
                        intent: INTENT.FOOTER.NORMANS_LIVE,
                    })}
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.SPORT_BET'), {
                        intent: INTENT.FOOTER.SPORT_BET,
                    })}
                </div>
            </div>
        );
    }

    renderLegalInformation(style) {
        return (
            <div style={style}>
                {this.renderHeader(this.resolveString('$APPLICATION_FOOTER.LEGAL_INFORMATION'))}
                <div>
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.RESPONSIBLE_GAMBLING'), {
                        intent: INTENT.FOOTER.RESPONSIBLE_GAMBLING,
                    })}
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.TERMS_AND_CONDITIONS'), {
                        intent: INTENT.FOOTER.TERMS_AND_CONDITIONS,
                    })}
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.PRIVACY_POLICY'), {
                        intent: INTENT.FOOTER.PRIVACY_POLICY,
                    })}
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.COOKIE_POLICY'), {
                        intent: INTENT.FOOTER.COOKIE_POLICY,
                    })}
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.SYSTEM_REQUIREMENTS'), {
                        intent: INTENT.FOOTER.SYSTEM_REQUIREMENTS,
                    })}
                    {this.renderLink(this.resolveString('$APPLICATION_FOOTER.CANAL_LINEA'), {
                        intent: INTENT.FOOTER.CANAL_LINEA,
                    })}
                </div>
            </div>
        );
    }

    renderPaymentImagesLinksRow(containerStyle) {
        let innerCommonContainerStyle = {};
        let containerWrapper = {};

        Object.assign(innerCommonContainerStyle, containerStyle, {
            ...this.style.greyBG,
            justifyContent: 'space-between',
            padding: '35px 20px',
        });
        Object.assign(containerWrapper, containerStyle, this.style.greyBG);

        return (
            <div style={containerWrapper}>
                <IconsRow
                    containerStyle={innerCommonContainerStyle}
                    icons={[
                        ...this.ICONS.PAYMENT.FIRST_ROW,
                        ...this.ICONS.PAYMENT.SECOND_ROW,
                        ...this.ICONS.PAYMENT.THIRD_ROW,
                    ]}
                />
            </div>
        );
    }

    renderCasinosImagesLinksRow(containerStyle) {
        let innerCommonContainerStyle = {};

        Object.assign(innerCommonContainerStyle, containerStyle, {
            justifyContent: 'space-around',
            padding: '15px 20px',
        });

        return (
            <div style={containerStyle}>
                <IconsRow
                    containerStyle={innerCommonContainerStyle}
                    icons={this.ICONS.CASINOS}
                    iconStyle={{margin: '0 5px'}}
                />
            </div>
        );
    }

    renderKLImageRow(containerStyle) {
        return (
            <div style={containerStyle}>
                <SimpleIcon config={this.ICONS.KINGS_LEAGUE} />
            </div>
        );
    }

    renderSponsorsRow(containerStyle) {
        return (
            <div style={containerStyle}>
                <SimpleIcon config={this.ICONS.KINGS_LEAGUE} />
            </div>
        );
    }

    renderPaymentImagesLinksNarrow(containerStyle) {
        let innerCommonContainerStyle = {};
        let containerWrapper = {};

        Object.assign(innerCommonContainerStyle, containerStyle, {
            ...this.style.greyBG,
            justifyContent: 'center',
            padding: '8px 20px',
        });
        Object.assign(containerWrapper, containerStyle, this.style.greyBG);

        return (
            <div style={containerWrapper}>
                <IconsRow containerStyle={innerCommonContainerStyle} icons={this.ICONS.PAYMENT.FIRST_ROW} />
                <IconsRow containerStyle={innerCommonContainerStyle} icons={this.ICONS.PAYMENT.SECOND_ROW} />
                <IconsRow containerStyle={innerCommonContainerStyle} icons={this.ICONS.PAYMENT.THIRD_ROW} />
            </div>
        );
    }

    renderImagesLinks3Row(containerStyle, labelStyle) {
        let outerCommonContainerStyle = {};
        let innerCommonContainerStyle = {};
        let playResponsiblyIcon = {};
        let playResponsiblyLabel = {...labelStyle, margin: 'unset', padding: '5px 0 0 0'};

        Object.assign(outerCommonContainerStyle, containerStyle, {
            justifyContent: 'center',
            flexWrap: 'wrap',
            ...this.style.greyBG,
        });
        Object.assign(innerCommonContainerStyle, containerStyle, {
            ...this.style.greyBG,
            justifyContent: 'center',
            alignItems: 'center',
            padding: '15px 20px',
        });
        Object.assign(playResponsiblyIcon, labelStyle, {
            width: '30em',
            fontWeight: '500',
            fontSize: '8px',
            flexDirection: 'column',
            alignItems: 'center',
            lineHeight: '18px',
            textAlign: 'center',
        });

        return (
            <div style={outerCommonContainerStyle}>
                {this.renderLink(this.resolveString('$APPLICATION_FOOTER.PLAY_RESPONSIBLY'), {
                    style: playResponsiblyLabel,
                })}
                <div style={innerCommonContainerStyle}>
                    <SimpleIcon config={this.ICONS.PLAY_RESPONSIBLE[0]} />
                    <div style={playResponsiblyIcon}>
                        <SimpleIcon config={this.ICONS.PLAY_RESPONSIBLE[1]} />
                        {this.resolveString('$APPLICATION_FOOTER.PLAY_RESPONSIBLY_ICON')}
                    </div>
                    <SimpleIcon config={this.ICONS.PLAY_RESPONSIBLE[2]} />
                    <SimpleIcon config={this.ICONS.PLAY_RESPONSIBLE[3]} />
                    <SimpleIcon config={this.ICONS.PLAY_RESPONSIBLE[4]} />
                </div>
            </div>
        );
    }

    renderImagesLinks3Narrow(containerStyle, labelStyle) {
        let iconStyle = {margin: '0 20px 0 0', backgroundSize: 'contain'};
        let innerCommonContainerStyle = {};
        let outerCommonContainerStyle = {};
        let sponsorsLevelStyle = {};

        Object.assign(sponsorsLevelStyle, labelStyle, {fontWeight: 'bold'});
        Object.assign(outerCommonContainerStyle, containerStyle, {justifyContent: 'center'});
        Object.assign(innerCommonContainerStyle, containerStyle, {
            ...this.style.greyBG,
            justifyContent: 'center',
            flexFlow: 'row wrap',
            padding: ' 0 20px',
        });

        return (
            <div style={outerCommonContainerStyle}>
                <IconsRow
                    containerStyle={innerCommonContainerStyle}
                    iconStyle={iconStyle}
                    icons={this.ICONS.PLAY_RESPONSIBLE}
                />
            </div>
        );
    }

    renderLinksRow(rowStyle, blockStyle) {
        return (
            <div style={rowStyle}>
                {this.renderDesktopTime(blockStyle)}
                {this.renderAboutSport(blockStyle)}
                {this.renderHelp(blockStyle)}
                {this.renderBettingRules(blockStyle)}
                {this.renderLegalInformation(blockStyle)}
                {this.renderContactUs(blockStyle)}
            </div>
        );
    }

    renderContactUs(style) {
        const {iconsContainer, icon} = this.style.regulations;
        return (
            <div style={style}>
                {this.renderHeaderButton(this.resolveString('$APPLICATION_FOOTER.CONTACT_US_ALT'))}
                <IconsRow icons={this.ICONS.SOCIAL_MEDIA} containerStyle={iconsContainer} iconStyle={icon} />
            </div>
        );
    }

    renderIcon(iconUrl, width, height, intent, imgStyle) {
        let onClick = null;
        let defaultImageStyle = imgStyle || {};
        let options = {
            minWidth: width,
            minHeight: height,
            cursor: intent ? 'pointer' : 'auto',
            backgroundImage: `url('${iconUrl}')`,
        };
        const imageStyle = Object.assign(defaultImageStyle, options);

        if (intent) {
            onClick = () => dispatch(IntentActions.publishIntent(intent.type, intent.data));
        }
        const style = uiStyle.mergeAndPrefix(this.style.icon_alt, imageStyle);

        return <div style={style} onClick={onClick} />;
    }

    renderResponsibleGamingLabel(style) {
        return <div style={style}>{this.resolveString('$APPLICATION_FOOTER.RESPONSIBLE_GAMBLING_WARNING')}</div>;
    }

    renderHorizontalSeparator(gradient, conf) {
        const style = Object.assign(
            {},
            {
                width: '100%',
                height: '2px',
                borderWidth: 0,
                margin: '0',
                display: 'block',
                alignSelf: 'center',
                ...resolveBackground(gradient),
            },
            conf
        );
        return <hr style={style} />;
    }

    renderWideLayout() {
        return (
            <div style={this.style.containerWide}>
                {this.renderResponsibleGamingLabel(this.style.responsibleGamingPanel)}
                {this.renderPaymentImagesLinksRow(this.style.contentRowContainer)}
                {this.renderSectionHeader(this.resolveString('$APPLICATION_FOOTER.WITH_GUARANTEE'))}
                {this.renderCasinosImagesLinksRow(this.style.contentRowContainer)}
                {this.renderSponsorsRow(this.style.contentRowContainer)}
                {this.renderImagesLinks3Row(this.style.contentSimpleRowContainer, this.style.footerLabel)}
                <div style={this.style.contentContainer}>
                    {this.renderLinksRow(this.style.linksRow, this.style.linkBlock)}
                </div>
            </div>
        );
    }

    removeBorder(style) {
        return Object.assign({}, style, {borderWidth: 0});
    }

    createMarkup(text) {
        return {__html: text};
    }

    renderFooterText(style, text) {
        return <div style={style}>{text}</div>;
    }

    renderFooterMarkup(style, text) {
        return <div style={style} dangerouslySetInnerHTML={this.createMarkup(text)} />;
    }

    renderTime() {
        return (
            <div style={this.style.narrowFooterLinkAlt}>
                <div style={this.style.narrowFooterLink}>{this.resolveString('$APPLICATION_FOOTER.TIME')}</div>
                <div style={this.style.narrowFooterLink}>
                    <CurrentTime timeOffset={UserSettingsSelectors.selectTimeOffset()} />
                </div>
            </div>
        );
    }

    renderLoginTime() {
        const {loginTime} = this.props;

        if (!loginTime) {
            return null;
        }

        return (
            <div>
                <div style={this.style.narrowFooterLinkAlt}>
                    <div style={this.style.narrowFooterLink}>
                        {this.resolveString('$APPLICATION_FOOTER.LOGIN_TIME')}
                    </div>
                    <SessionTime loginTime={loginTime} />
                </div>
                {this.renderHorizontalSeparator(COLOR.BRAND.BACKGROUND2)}
            </div>
        );
    }

    renderNarrowLinks() {
        let aboutFooter = {
            caption: '$APPLICATION_FOOTER.ABOUT_SPORT',
            items: [
                {
                    text: '$APPLICATION_FOOTER.ABOUT_US',
                    intent: INTENT.FOOTER.ABOUT_US,
                },
                {
                    text: '$APPLICATION_FOOTER.FIND_OUR_STORIES',
                    intent: INTENT.FOOTER.FIND_OUR_STORIES,
                },
            ],
        };
        let helpSection = {
            caption: '$APPLICATION_FOOTER.HELP',
            items: [
                {
                    text: '$APPLICATION_FOOTER.PAYMENT_METHODS',
                    intent: INTENT.FOOTER.PAYMENT_METHODS,
                },
                {
                    text: '$APPLICATION_FOOTER.FAQ',
                    intent: INTENT.FOOTER.FAQ,
                },
                {
                    text: '$APPLICATION_FOOTER.CLAIMS_RESOLUTION',
                    intent: INTENT.FOOTER.CLAIMS_RESOLUTION,
                },
                {
                    text: '$APPLICATION_FOOTER.WANT_TO_AFFILIATE',
                    intent: INTENT.FOOTER.AFFILIATES,
                },
            ],
        };
        let bettingSection = {
            caption: '$APPLICATION_FOOTER.BETTING_RULES',
            items: [
                {
                    text: '$APPLICATION_FOOTER.LIVE_STADTARDS',
                    intent: INTENT.FOOTER.NORMANS_LIVE,
                },
                {
                    text: '$APPLICATION_FOOTER.SPORT_BET',
                    intent: INTENT.FOOTER.SPORT_BET,
                },
            ],
        };
        let legalSection = {
            caption: '$APPLICATION_FOOTER.LEGAL_INFORMATION',
            items: [
                {
                    text: '$APPLICATION_FOOTER.RESPONSIBLE_GAMBLING',
                    intent: INTENT.FOOTER.RESPONSIBLE_GAMBLING,
                },
                {
                    text: '$APPLICATION_FOOTER.TERMS_AND_CONDITIONS',
                    intent: INTENT.FOOTER.TERMS_AND_CONDITIONS,
                },
                {
                    text: '$APPLICATION_FOOTER.PRIVACY_POLICY',
                    intent: INTENT.FOOTER.PRIVACY_POLICY,
                },
                {
                    text: '$APPLICATION_FOOTER.COOKIE_POLICY',
                    intent: INTENT.FOOTER.COOKIE_POLICY,
                },
                {
                    text: '$APPLICATION_FOOTER.SYSTEM_REQUIREMENTS',
                    intent: INTENT.FOOTER.SYSTEM_REQUIREMENTS,
                },
                {
                    text: '$APPLICATION_FOOTER.CANAL_LINEA',
                    intent: INTENT.FOOTER.CANAL_LINEA,
                },
            ],
        };
        let linksContainerStyle = {marginBottom: '20px'};
        return (
            <div style={linksContainerStyle}>
                {this.renderFooterLinksSection(aboutFooter)}
                {this.renderFooterLinksSection(helpSection)}
                {this.renderFooterLinksSection(bettingSection)}
                {this.renderFooterLinksSection(legalSection)}
            </div>
        );
    }

    renderNarrowLayout() {
        let contactUsStyle = {};

        Object.assign(contactUsStyle, this.style.linkBlockNarrow, {marginTop: '10px'});

        return (
            <div style={this.style.containerNarrow}>
                {this.renderResponsibleGamingLabel(this.style.responsibleGamingPanel)}
                {this.renderPaymentImagesLinksNarrow(this.style.contentNarrowRowContainerAlt)}
                {this.renderSectionHeader(this.resolveString('$APPLICATION_FOOTER.WITH_GUARANTEE'))}
                {this.renderCasinosImagesLinksRow(this.style.contentNarrowRowContainerAlt)}
                {this.renderKLImageRow(this.style.contentRowContainer)}
                {this.renderSectionHeader(
                    this.resolveString('$APPLICATION_FOOTER.PLAY_RESPONSIBLY'),
                    this.style.greyBG
                )}
                {this.renderImagesLinks3Narrow(this.style.contentNarrowRowContainer, this.style.footerLabelNarrow)}
                {this.renderTime()}
                {this.renderLoginTime()}
                {this.renderNarrowLinks()}
                {this.renderContactUs(contactUsStyle)}
            </div>
        );
    }

    render() {
        return isMobile() ? this.renderNarrowLayout() : this.renderWideLayout();
    }
}

/////////////////////////////////////////////
// Styling

ApplicationFooter.getStyle = function (config, applicationMode, merge) {
    const IS_WIDE = applicationMode !== 'mobile';
    const debugColor = COLORS.DEBUG_COLOR;

    let container = {
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
    };

    const footerText = {
        color: COLOR.BRAND.BACKGROUND5,
        fontSize: FONT.SIZE_MEDIUM,
        fontWeight: FONT.WEIGHT_BOLD,
    };

    const text = {
        display: IS_WIDE ? 'flex' : 'block',
        fontWeight: 400,
        fontSize: FONT.SIZE_MEDIUM,
        lineHeight: 1.5,
        color: COLOR.BRAND.BACKGROUND5,
    };

    const linkRowHeader = merge(text, {
        color: COLOR.BRAND.ACCENT2,
        textTransform: 'uppercase',
        marginBottom: IS_WIDE ? '10px' : '0px',
        fontWeight: 'bold',
    });

    const linkButtonHeader = merge(text, {
        display: 'block',
        textAlign: 'center',
        ...resolveBackground(COLOR.BRAND.ACCENT2),
        color: COLOR.BRAND.FOREGROUND5,
        marginBottom: IS_WIDE ? '10px' : '0px',
        fontWeight: 500,
        width: '100%',
        cursor: 'pointer',
        lineHeight: '2',
    });

    const link = merge(text, {
        color: COLOR.BRAND.BACKGROUND5,
        cursor: 'pointer',
    });

    const time = merge(text, {
        cursor: 'default',
        fontWeight: 'bold',
    });

    const narrowFooterLink = merge(link, {
        lineHeight: '41px',
        margin: '0 10px 0 10px',
        fontSize: '12px',
    });

    const narrowFooterLinkSmall = merge(link, {
        lineHeight: '1em',
        margin: '0 10px',
        fontSize: '12px',
        boxSizing: 'border-box',
    });

    const narrowFooterLinkAlt = merge(link, {
        lineHeight: '41px',
        display: 'flex',
        justifyContent: 'center',
    });

    const timeCapture = merge(narrowFooterLink, {
        color: COLOR.BRAND.FOREGROUND1,
        fontWeight: 'bold',
    });

    const linkBlock = {
        minWidth: '180px',
        alignSelf: 'flex-start',
    };

    const linkBlockNarrow = {
        textAlign: 'center',
        margin: '0 20% 10px 20%',
    };

    const linksRow = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        marginTop: '30px',
        marginBottom: '35px',
    };

    const debugLink = merge({}, link, {
        color: debugColor,
    });

    const footerNarrowLinks = merge({}, link, {
        paddingLeft: '11px',
        paddingRight: '20px',
    });
    const footerNarrowLinksContainer = {
        width: '100%',
        marginBottom: '35px',
    };
    const linkSection = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    };
    const flexContainer = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };
    const regulations = {
        iconsContainer: {
            ...flexContainer,
            _mobile_flexWrap: 'wrap',
        },
        icon: {
            margin: '0 8px',
            _mobile_margin: '8px 8px 16px',
        },
    };

    const guaranteeContainer = {
        iconStyle: {
            backgroundSize: 'contain',
        },
    };
    const sectionHeader = {
        ...footerText,
        ...resolveBackground(COLOR.BRAND.BACKGROUND1),
        padding: '5px 15px 5px 15px',
        textAlign: 'center',
    };

    const greyBG = {
        ...resolveBackground(COLOR.BASE.PAGE),
    };

    return {
        guaranteeContainer,
        regulations,
        sectionHeader,
        footerText,
        greyBG,
        footerNarrowLinks,
        footerNarrowLinksContainer,
        IS_WIDE,
        linksRow,
        linkBlock,
        linkBlockNarrow,
        link,
        time,
        narrowFooterLink,
        narrowFooterLinkSmall,
        narrowFooterLinkAlt,
        timeCapture,
        linkRowHeader,
        linkButtonHeader,
        responsibleGamingPanel: {
            lineHeight: '27px',
            width: '100%',
            textAlign: 'center',
            verticalAlign: 'middle',
            fontSize: '12px',
            color: COLOR.BRAND.BACKGROUND5,
            ...resolveBackground(COLOR.BASE.PAGE),
            borderStyle: 'solid',
            borderWidth: '1px 0 0 0',
            borderColor: COLOR.BRAND.BACKGROUND2,
        },
        icon_alt: getConfigByContext(
            {
                alignSelf: 'center',
                margin: '15px 5px 15px',
                _mobile_margin: '5px 5px',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
            },
            applicationMode
        ),
        footerLabel: merge({}, debugLink, {
            ...footerText,
            alignSelf: 'center',
            margin: '0 20px 0 0',
        }),
        footerLabelNarrow: merge({}, debugLink, {
            alignSelf: 'center',
            fontSize: '12px',
            color: COLOR.BRAND.BACKGROUND5,
            flexBasis: '100%',
            textAlign: 'center',
            margin: '10px 0 0 0',
        }),
        footerLabelFlexStart: merge({}, debugLink, {
            alignSelf: 'flex-start',
            padding: '20px 0',
            fontSize: '12px',
            margin: '0 15px 0 0',
        }),
        footerTextContactUs_1: merge({}, debugLink, {
            fontSize: '12px',
            cursor: 'auto',
            margin: '4px 0',
        }),
        footerTextContactUs_2: merge({}, debugLink, {
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'auto',
        }),
        footerLabelAlt: merge({}, debugLink, {
            alignSelf: 'center',
            fontSize: '12px',
            fontWeight: 'bold',
            width: '93px',
            margin: '0 15px 0 15px',
            textAlign: 'center',
        }),
        containerWide: merge(
            {
                flexDirection: 'column',
                alignItems: 'left',
            },
            container
        ),
        containerNarrow: merge(container, {
            ...resolveBackground(COLOR.BRAND.FOREGROUND5),
            flexDirection: 'column',
            borderStyle: 'none',
            borderColor: '#bcb5b9',
            boxSizing: 'border-box',
            marginTop: '0',
        }),
        contentContainer: {
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            ...resolveBackground(COLOR.BRAND.FOREGROUND5),
        },
        contentSimpleRowContainer: {
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            minHeight: '85px',
            ...resolveBackground(COLOR.BRAND.FOREGROUND5),
        },
        contentRowContainer: {
            height: 'auto',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            ...resolveBackground(COLOR.BRAND.FOREGROUND5),
            borderColor: COLOR.BRAND.ACCENT2,
            borderWidth: '1px',
        },
        linkSectionNarrow: merge(
            {
                alignItems: 'center',
                paddingTop: 8,
                paddingBottom: 8,
            },
            linkSection
        ),
        linkUnderline: merge(
            {
                textDecoration: 'underline',
            },
            link
        ),

        contentNarrowRowContainer: {
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            width: '100%',
            ...resolveBackground(COLOR.BRAND.FOREGROUND5),
        },
        contentNarrowRowContainerAlt: {
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            width: '100%',
            ...resolveBackground(COLOR.BRAND.FOREGROUND5),
            flexWrap: 'wrap',
        },
        contentColumnContainer: {
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
            ...resolveBackground(COLOR.BRAND.BACKGROUND5),
        },
        contentColumnContainerDark: {
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
            ...resolveBackground(COLOR.BRAND.BACKGROUND2),
            borderStyle: 'solid none none',
            borderImage: 'green',
            borderWidth: '2px',
            padding: '10px 0 0 0',
        },
    };
};

const mapStateToProps = state => ({
    loginTime: authenticationSelectors.selectLoginTime(state),
    aliraLoginInfo: aliraSelectors.selectLoginInfo(state),
});

export default connect(mapStateToProps)(ApplicationFooter);
